module.exports = __webpack_public_path__ + "img/add_lock_2.fbdf4540.png";